import { render, staticRenderFns } from "./RatingPlayersTable.vue?vue&type=template&id=32f76642&scoped=true"
import script from "./RatingPlayersTable.vue?vue&type=script&lang=js"
export * from "./RatingPlayersTable.vue?vue&type=script&lang=js"
import style0 from "./RatingPlayersTable.vue?vue&type=style&index=0&id=32f76642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f76642",
  null
  
)

export default component.exports